import { CommonModule } from '@angular/common';
import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { goBack } from '../../../../common/common';
import { Resource } from '../../../../model/resources.model';
import {ApiService, CustomHttpParams} from 'src/app/services/api.service';

@Component({
  selector: 'app-create-resource-index',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './create-resource.component.html',
  styleUrl: './create-resource.component.scss'
})
export class CreateResourceComponent implements OnInit, OnDestroy {

  // FORM
  resourcesForm = new FormGroup({
    id: new FormControl<string>('', [Validators.required]),
    programUnit: new FormControl<string>('', [Validators.required]),
    label: new FormControl<string>(''),
  });

  unsubscribe = new Subject<void>();
  public editing: boolean = false;
  public resourceId: number;
  public router: Router;
  public error: string | null = null;
  public resource: Resource = {
    id: 0,
    resource_id: '',
    updated_by: '',
    program_unit: '',
    events: [],
    vens: [],
    label: ''
  };

  constructor(private injector: Injector, private createResources: ApiService){
    this.router = injector.get(Router);
    this.router.events.subscribe((event: any) => {
      if (event?.snapshot?.params.id) {
        this.editing = true;
        this.resourceId = event.snapshot.params.id;
      }
    });
  }

  setFormsDefaultValue(){
    this.resourcesForm.controls.id.setValue(this.resource?.resource_id);
    this.resourcesForm.controls.programUnit.setValue(this.resource?.program_unit);
    this.resourcesForm.controls.label.setValue(this.resource?.label || '');
  }

  ngOnInit(): void {
    if (this.editing) {
      const queryParams: CustomHttpParams = {
        'id': this.resourceId
      };
      this.createResources.getResources(queryParams).subscribe({
        next: (response: any) => {
          if (response && response.length > 0) {
            this.resource = response.find((resource: Resource) => resource.id === Number(this.resourceId)) || this.resource;
            this.setFormsDefaultValue();
          } else {
            this.error = "Resource not found";
          }
        },
        error: (err) => {
          console.error(err);
          this.error = err;
        }
      });
    }

    this.setupFormValueChanges();
  }

  setupFormValueChanges() {
    this.resourcesForm.controls.id.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(
      (val: any) => this.resource.resource_id = val
    );

    this.resourcesForm.controls.programUnit.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(
      (val: any) => this.resource.program_unit = val
    );

    this.resourcesForm.controls.label.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(
      (val: any) => this.resource.label = val
    );
  }

  save(){
    if (this.resourcesForm.invalid) {
      this.error = 'Please fill out all fields correctly and try again.';
      return;
    }

    if (this.editing) {
      this.createResources.editResources(this.resource).subscribe({
        next: () => {
          goBack('/resources', this.router);
        },
        error: (err) => {
          console.error(err);
          this.error = err;
        }
      });
    } else {
      const createResourceData = {
        "resource_id": this.resource.resource_id,
        "program_unit": this.resource.program_unit,
        "label": this.resource.label
      };

      this.createResources.createResources(createResourceData).subscribe({
        next: () => {
          goBack('/resources', this.router);
        },
        error: (err) => {
          console.error(err);
          this.error = err;
        }
      });
    }
  }

  backPage(url: string, router: Router){
    goBack(url, router);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
